module.exports = __webpack_public_path__ + "img/logo-full.d3175aa9.svg";